import React from "react"
import "./banner.css"

export class BusinesspageBannerContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    const html = (
      <>
        <div className="banner-content">
          <div
            className="banner-content-background-new"
            style={{
              backgroundImage: `url(/banner-gradient-background-1.png)`,
            }}
          ></div>
          <div className="banner-title homepage-banner-title business-banner-title school-banner-title">
            Meaningful brand awareness delivered directly
            <br />
            inside classrooms nationwide
          </div>
        </div>
      </>
    )
    return html
  }
}
